import { createContext } from 'react';
import type { SpelVerbinding } from './verbinding';

/** De verbinding van de dichtstbijzijnde `SpelProvider`; `null` daarbuiten. */
export const SpelContext = createContext<SpelVerbinding | null>(null);
